export const getUserZoneId = (state: any) => {
  return state.auth.user?.zoneId;
};
